import React, { Component } from "react";

import CmsHistory from "../CmsHisory/CmsHistory";
import CmsUnitChangePanel from "./CmsUnitChangePanel";
import CmsCompanyTable from "./CmsCompanyTable";
import Preloader from "../../../shared/items/static/preloader";
import { withCompanies } from "../../../shared/containers/containerCompanies";
import { withAuth } from "../../../shared/containers/containerAuth";
import { states } from "../../../reducers/queriesStates";
import { withServiceHistory } from "../../../shared/containers/contaynerServiceHistory";
import { withUnits } from "../../../shared/containers/containerUnits";

import HistoryIcon from "@mui/icons-material/History";
import CmsTransferUnitsTools from "./CmsTransferUnitsTools";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

import clsx from "clsx";
import "./cellTable.css";

import CmsDevicePanel from "../CmsDevices/CmsDevicePanel";
import { withDevices } from "../../../shared/containers/containerDevices";
import styles from "./cmsCompany.module.scss";
import CmsUsersCompanyPanel from "../CmsUsers/CmsUsersCompanyPanel";
import CmsCompanyEntering from "./CmsCompanyEntering";
import CmsCompanyIntegrations from "../CmsCompanyIntegrations/CmsCompanyIntegrations";
import CmsCompanyRetranslation from "./CmsCompanyRetranslation/CmsCompanyRetranslation";

const PATH = "/cms/companies/";

class CmsCompany extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectUnits: [],
      isOpenHistoryView: false,
      isOpenUnitActionPanel: false,
      madalPageTitle: null,
      changeDeviceId: null,
      unitId: null,
      deviceId: null,
      companyId: null,
      filterAction: null,
      page: 1,
      tabIndex: 0,
    };
  }

  componentDidMount() {
    const companyId = window.location.pathname.replace(PATH, "");
    this.setState({ companyId });

    const { onGetCompany } = this.props;
    onGetCompany(companyId);

    const { dataStateProtocolMarkers, onGetProtocolMarkers } = this.props;

    if (dataStateProtocolMarkers === states.NOT_REQUESTED) {
      onGetProtocolMarkers();
    }
  }

  componentDidUpdate(prevProps) {
    const { companyDataState, company } = this.props;

    if (companyDataState === states.READY && prevProps.companyDataState === states.REQUEST) {
      window.document.title = company.title;
      if (window.location.search !== "") {
        this.onViewPanelUnit(window.location.search.replace("?unitId=", ""));
      }
    }
  }

  getColumns() {
    const { protocolMarkers } = this.props;

    const renderTypeCell = (params) => {
      return protocolMarkers.protocolMarkers.filter((x) => x.value === params.value)[0].title;
    };

    const renderSensorCell = (params) => {
      return (
        <div style={{ display: "flex", fontSize: "11px" }}>
          {Object.keys(params.value).map((key, index) => {
            return (
              <TooltipWrapper title={params.value[key]} position="top">
                <div key={index}>
                  <div>{key}&nbsp;</div>
                </div>
              </TooltipWrapper>
            );
          })}
        </div>
      );
    };

    const styleInactive = (params) => {
      return clsx("inActive-cell", {
        inActiveNegative: params.value,
      });
    };

    return [
      {
        field: "title",
        headerName: "Подпись ",
        width: 250,
      },
      {
        field: "registerNumber",
        headerName: "Регистрационный номер ",
        width: 110,
      },
      {
        field: "imei",
        headerName: "IMEI",
        width: 150,
      },
      {
        field: "numberSim",
        headerName: "Номер SIM",
        width: 230,
      },
      {
        field: "phone",
        headerName: "Телефон",
        width: 180,
      },
      {
        field: "sensors",
        headerName: "Датчики",
        renderCell: renderSensorCell,
        width: 400,
      },
      {
        field: "type",
        headerName: "Марка устройства",
        renderCell: renderTypeCell,
        width: 150,
      },
      {
        field: "guaranteeStartDate",
        headerName: "Гарантия с",
        type: "date",
        width: 100,
      },
      {
        field: "guaranteeMounths",
        headerName: "Срок (мес.)",
        width: 100,
      },
      {
        field: "inActive",
        headerName: "Не активна",
        type: "boolean",
        cellClassName: styleInactive,
        width: 100,
      },
    ];
  }

  onSelectUnitHandler(selectUnits) {
    this.setState({ selectUnits });
  }

  onViewHistoryUnit(unitId, title, registerNumber) {
    const { onGetServiceHistory } = this.props;
    const { page, filterAction } = this.state;

    onGetServiceHistory({ unitId, page, count: 10, action: filterAction });
    this.setState({
      unitId,
      filterAction: filterAction,
      isOpenHistoryView: true,
      isOpenUnitActionPanel: false,
      madalPageTitle: `История обслуживания ${title} ${registerNumber}`,
    });
  }

  onViewHistoryDevice(deviceId, imei, type) {
    const { onGetServiceHistory } = this.props;

    onGetServiceHistory({ deviceId });
    this.setState({
      isOpenHistoryView: true,
      isOpenUnitActionPanel: false,
      madalPageTitle: `История обслуживания ${imei} ${type}`,
    });
  }

  onViewHistoryCompany() {
    const { onGetServiceHistory, company } = this.props;
    const { page, filterAction, companyId } = this.state;

    onGetServiceHistory({ companyId, page, count: 10, action: filterAction });

    this.setState({
      isOpenHistoryView: true,
      isOpenUnitActionPanel: false,
      madalPageTitle: `История обслуживания ${company.title}`,
    });
  }

  onViewPanelUnit(unitId) {
    const { company, onSelectToChangeUnit } = this.props;

    const unitToChange = company.units.filter((x) => {
      return x.id === unitId;
    })[0];

    this.setState({
      isOpenUnitActionPanel: true,
      isOpenHistoryView: false,
    });

    onSelectToChangeUnit(unitToChange);
  }

  onCloseModal() {
    const { onClearToChangeUnit } = this.props;
    this.setState({
      isOpenHistoryView: false,
      isOpenUnitActionPanel: false,
      madalPageTitle: null,
      page: 1,
      unitId: null,
      deviceId: null,
      filterAction: null,
    });

    onClearToChangeUnit();
    this.setState({});
  }

  onViewDevicePanel(deviceId = null) {
    this.setState({ changeDeviceId: deviceId, isOpenHistoryView: false, isOpenUnitActionPanel: false });
    const { companyId, changeDeviceId } = this.state;

    if (deviceId === null && changeDeviceId !== null) {
      const { onGetCompany } = this.props;
      onGetCompany(companyId);
    }
  }

  onChangePage(page) {
    const { onGetServiceHistory } = this.props;
    const { unitId, companyId, deviceId, filterAction } = this.state;

    const _companyId = unitId !== null || deviceId !== null ? null : companyId;

    onGetServiceHistory({ unitId, companyId: _companyId, deviceId, page, count: 10, action: filterAction });
    this.setState({ page });
  }

  onChangeFilter(filterAction) {
    const { onGetServiceHistory } = this.props;
    const { unitId, companyId, deviceId, page } = this.state;

    const _companyId = unitId !== null || deviceId !== null ? null : companyId;

    onGetServiceHistory({ unitId, companyId: _companyId, deviceId, page, count: 10, action: filterAction });
    this.setState({ filterAction });
  }

  companyPanel() {
    const { selectUnits, isOpenHistoryView, isOpenUnitActionPanel, madalPageTitle, changeDeviceId, page } = this.state;
    const { company, data } = this.props;

    return (
      <div>
        <CmsCompanyEntering />
        {changeDeviceId !== null ? (
          <CmsDevicePanel onViewDevicePanel={this.onViewDevicePanel.bind(this)} deviceId={changeDeviceId} />
        ) : null}
        {isOpenHistoryView ? (
          <CmsHistory
            title={madalPageTitle}
            onClose={this.onCloseModal.bind(this)}
            page={page}
            onChangeStore={this.onChangePage.bind(this)}
            onChangeFilter={this.onChangeFilter.bind(this)}
          />
        ) : null}
        {isOpenUnitActionPanel && data.permissions.includes(11001) ? (
          <CmsUnitChangePanel onClose={this.onCloseModal.bind(this)} companyId={company.id} />
        ) : null}
        <CmsTransferUnitsTools selectUnits={selectUnits} companyId={company.id} />
        <CmsCompanyTable
          onSelectUnitHandler={this.onSelectUnitHandler.bind(this)}
          onViewHistoryUnit={this.onViewHistoryUnit.bind(this)}
          onViewPanelUnit={this.onViewPanelUnit.bind(this)}
          onViewHistoryDevice={this.onViewHistoryDevice.bind(this)}
          onViewDevicePanel={this.onViewDevicePanel.bind(this)}
        />
      </div>
    );
  }

  setTabIndex(index) {
    this.setState({ tabIndex: index });
  }

  getTabs() {
    const { tabIndex } = this.state;
    const { company } = this.props;

    return (
      <div className={styles.cmsTabsContainer}>
        <div
          className={tabIndex === 0 ? styles.cmsTabActive : styles.cmsTab}
          style={{ display: "flex" }}
          onClick={this.setTabIndex.bind(this, 0)}
        >
          <h2>{company.title}</h2>
          <div onClick={this.onViewHistoryCompany.bind(this)}>
            <TooltipWrapper title={`Открыть панель истории ${company.title}`} position="top">
              <div className={"activetyHover"}>
                <HistoryIcon fontSize="small" />
              </div>
            </TooltipWrapper>
          </div>
        </div>
        <div className={tabIndex === 1 ? styles.cmsTabActive : styles.cmsTab} onClick={this.setTabIndex.bind(this, 1)}>
          <h2>Пользователи</h2>
        </div>
        <div className={tabIndex === 2 ? styles.cmsTabActive : styles.cmsTab} onClick={this.setTabIndex.bind(this, 2)}>
          <h2>Интеграции</h2>
        </div>
        <div className={tabIndex === 3 ? styles.cmsTabActive : styles.cmsTab} onClick={this.setTabIndex.bind(this, 3)}>
          <h2>Ретрансляции</h2>
        </div>
      </div>
    );
  }

  viewTab() {
    const { tabIndex, companyId } = this.state;

    switch (tabIndex) {
      case 0:
        return this.companyPanel();
      case 1:
        return <CmsUsersCompanyPanel companyId={companyId} />;
      case 2:
        return <CmsCompanyIntegrations companyId={companyId} />;

      case 3:
        return <CmsCompanyRetranslation companyId={companyId} />;
      default:
        return null;
    }
  }

  render() {
    const { company } = this.props;

    return (
      <div>
        {company !== null ? (
          <div>
            {this.getTabs()}
            {this.viewTab()}
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Preloader />
          </div>
        )}
      </div>
    );
  }
}

export default withDevices(withUnits(withCompanies(withServiceHistory(withAuth(CmsCompany)))));
